import { Grid, Typography } from "@mui/material";

import Pagination from "components/Pagination";
import React from "react";
import Table from "components/Table";
import WrapperAction from "./Component/WrapperAction";
import WrapperAmount from "./Component/WrapperAmount";

const headers = [
  {
    name: "Amount",
    key: "amount",
  },
  {
    name: "Type",
    key: "type",
  },
  {
    name: "Time",
    key: "time",
  },
  {
    name: "Date ",
    key: "date",
  },
  {
    name: "Action ",
    key: "action",
  },
];

function TableReferralHistory({
  referralIsPaidList,
  getReferralIsPaidList,
  setDetailsReferral,
  setOpenDetailsReferralModal,
}) {
  const formattedDataList = referralIsPaidList?.data?.map((data) => {
    return {
      amount: <WrapperAmount data={data} />,
      type: (
        <Typography variant="h5" color="text.main">
          {data?.type}
        </Typography>
      ),
      time: (
        <Typography variant="h5" color="text.main">
          {data?.time}
        </Typography>
      ),
      date: (
        <Typography variant="h5" color="text.main">
          {data?.date}
        </Typography>
      ),
      action: (
        <WrapperAction
          data={data}
          setDetailsReferral={setDetailsReferral}
          setOpenDetailsReferralModal={setOpenDetailsReferralModal}
        />
      ),
    };
  });

  const handleChangePaginate = ({ page, perPage }) => {
    getReferralIsPaidList({ pageNumber: page, pageSize: perPage });
  };

  return (
    <>
      <Grid item xs={12} mt={1}>
        <Table headers={headers} items={formattedDataList} hideBorders={true} />
      </Grid>

      <Grid item xs={12} mt={2}>
        <Pagination
          count={referralIsPaidList?.totalPages}
          perPage={referralIsPaidList?.pageSize}
          onChange={handleChangePaginate}
        />
      </Grid>
    </>
  );
}

export default TableReferralHistory;
